module.exports = __webpack_public_path__ + "img/bg.5cd8ab79.jpg";